import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/observable/combineLatest';
import 'rxjs/add/operator/switchMap';

import { UniqueIdGenerator } from './unique-id-generator';
import { BackendService } from './backend.service';

import { AngularFireDatabase, FirebaseListObservable,
         FirebaseObjectObservable } from 'angularfire2/database';
import { AngularFireAuth } from 'angularfire2/auth';
import * as firebase from 'firebase';



@Injectable()
export class DBService {
  private adminUID;

  constructor(
    private backendService: BackendService,
    private db: AngularFireDatabase,
    private afAuth: AngularFireAuth
  ) {
    afAuth.authState.subscribe(auth => {
      if (auth != null && auth.uid) {
        this.adminUID = auth.uid;
      }
    });
  }


  getRecentForumPosts() {

    return this.db.list('/forums')
                  .switchMap(forums => {
                    let list = [];
                    forums.map(forum => {
                      list.push(this.db.list(`/posts/${forum.$key}`)
                        .map( posts => {
                          return posts.map( post => {
                            post.forumKey = forum.$key;
                            post.type = 'question';

                            /*return this.db.list(`/comments/${post.$key}`)
                              .map( comments => {
                                let arr = [post];
                                comments.map( comment => {
                                  comment.postKey = post.$key;
                                  comment.forumKey = forum.$key;
                                  comment.title = `Re: ${post.title}`;
                                  comment.type = 'answer';
                                  arr.push(comment);
                                });
                                return arr;
                              }); */

                            return post;

                          });
                        }));
                    });


                    return Observable.combineLatest(list, (...args: any[]) => {
                      let posts = args.reduce((a,b) => {
                        return a.concat(b);
                      }, []);

                      let sorted = posts.sort((a, b) => {
                        if (a.commentTimestamp && a.commentTimestamp != 0) {

                        }
                        return b.timestamp - a.timestamp
                      });

                      return sorted.slice(0,6);
                    });
                  });

  }

  getForums(): FirebaseListObservable<any[]> {
    return this.db.list('/forums');
  }

  getForum(forumKey): FirebaseObjectObservable<any> {
    return this.db.object(`/forums/${forumKey}`);
  }

  addForum(forum) {
    forum.timestamp = firebase.database.ServerValue.TIMESTAMP;
    this.db.list('/forums').push(forum);
  }

  updateForum(key, value) {
    this.db.list('/forums').update(key, value);
  }

  deleteForum(key) {
    this.db.list('/forums').remove(key);
  }

  getPosts(key): FirebaseListObservable<any[]> {
    return this.db.list(`/posts/${key}`);
  }

  getPost(forumKey, postKey): FirebaseObjectObservable<any> {
    return this.db.object(`/posts/${forumKey}/${postKey}`);
  }

  addPost(forumKey, post) {
    post.timestamp = firebase.database.ServerValue.TIMESTAMP;
    post.creatorKey = this.adminUID;
    this.db.list(`/posts/${forumKey}`).push(post);
  }

  updatePost(forumKey, postKey, post) {
    this.db.list(`/posts/${forumKey}`).update(postKey, post);
  }

  deletePost(forumKey, postKey) {
    this.db.list(`/posts/${forumKey}`).remove(postKey);
  }

  getComments(postKey): FirebaseListObservable<any[]> {
    return this.db.list(`/comments/${postKey}`);
  }

  addComment(forumKey, postKey, comment) {
    comment.timestamp = firebase.database.ServerValue.TIMESTAMP;
    comment.creatorKey = this.adminUID;
    this.db.list(`/comments/${postKey}`).push(comment);

    let obj = { commentTimestamp: firebase.database.ServerValue.TIMESTAMP };
    this.db.list(`/posts/${forumKey}`).update(postKey, obj);
  }

  updateComment(postKey, commentKey, comment) {
    this.db.list(`/comments/${postKey}`).update(commentKey, comment);
  }

  deleteComment(postKey, commentKey) {
    this.db.list(`/comments/${postKey}`).remove(commentKey);
  }


  getCompanies(): FirebaseListObservable<any[]> {
    return this.db.list('/companies', {
      query: {
        orderByChild: 'companyType',
        equalTo: 'member'
      }
    });
  }

  getCompany(key): FirebaseObjectObservable<any> {
    return this.db.object(`/companies/${key}`);
  }

  addCompany(company, profileImg, coverImg) {
    company.creationTimestamp = firebase.database.ServerValue.TIMESTAMP;
    this.db.list('/companies').push(company).then( item => {
      if (profileImg) {
        firebase.storage().ref().child(`vendors/${item.key}/profileImage`)
                                .put(profileImg);
      }

      if (coverImg) {
        firebase.storage().ref().child(`vendors/${item.key}/coverImage`)
                                .put(coverImg);
      }
    });
  }

  updateCompany(key, company, profileImg, coverImg) {
    this.db.list('/companies').update(key, company);

    if (profileImg) {
      firebase.storage().ref().child(`vendors/${key}/profileImage`)
                              .put(profileImg);
    }

    if (coverImg) {
      firebase.storage().ref().child(`vendors/${key}/coverImage`)
                              .put(coverImg);
    }
  }

  deleteCompany(key) {
    console.log(`Delete: ${key}`);
    this.db.list('/companies/').remove(key);
    this.db.list('/users', {
      query: {
        orderByChild: 'companyKey',
        equalTo: key
      }
    }).subscribe( users => {
      users.map( user => {
         if (user.$key != null) {
          console.log(`Key is ${user.$key}`);
          this.db.list('/users/').remove(user.$key);
          firebase.storage().ref().child(`users/${user.$key}`).delete();
        } else {
          console.log("Key is null. Skipping...");
        }
      });
    });

    // TODO De-auth users

    return firebase.storage().ref().child(`vendors/${key}`).delete();
  }

  getCompanyUsers(key): FirebaseListObservable<any[]> {
    return this.db.list('/users', {
      query: {
        orderByChild: 'companyKey',
        equalTo: key
      }
    });
  }

  inviteMember(member) {
    /*member.creationTimestamp = firebase.database.ServerValue.TIMESTAMP;
    this.db.list('/users').push(member); */

  }

  getMembers(): FirebaseListObservable<any[]> {
    return this.db.list('/users');
  }

  getVendors(): FirebaseListObservable<any[]> {
    return this.db.list('/companies', {
      query: {
        orderByChild: 'companyType',
        equalTo: 'vendor'
      }
    });
  }

  getVendorGallery(key) {
    return this.db.list(`/companies/${key}/gallery`);
  }

  addToVendorGallery(company, file) {
    let key = UniqueIdGenerator.generate();
    if (!company.gallery) {
      company.gallery = {};
    }
    company.gallery[key] = file.name;

    return firebase.storage().ref().child(`vendors/${company.$key}/gallery/${key}`)
                             .put(file)
                             .then( file => {
                                this.db.list('/companies/').update(company.$key, company);
                              });
  }

  removeVendorGalleryPhoto(company, fileKey) {
    firebase.storage().ref().child(`vendors/${company.$key}/gallery/${fileKey}`)
                            .delete();
    return this.db.list(`/companies/${company.$key}/gallery`).remove(fileKey);
  }


  getMember(key): FirebaseObjectObservable<any> {
    return this.db.object(`/users/${key}`);
  }

  addMember(member, profileImg) {
    member.creationTimestamp = firebase.database.ServerValue.TIMESTAMP;
    this.db.list('/users').push(member).then( item => {
      if (profileImg) {
        firebase.storage().ref().child(`users/${item.key}/profileImage`)
                                .put(profileImg);
      }
    });
  }

  updateMember(key, member, profileImg) {
    this.db.list('/users').update(key, member);

    if (profileImg) {
      firebase.storage().ref().child(`users/${key}/profileImage`)
                              .put(profileImg);
    }
  }

  deleteMember(key) {
    this.db.list('/users/').remove(key);
    firebase.storage().ref().child(`users/${key}`).delete();
    return this.backendService
                         .deauthUser(key)
                         .subscribe( data => {
                            console.log("DBS: ", data);
                         });
  }

  getMemberGallery(key) {
    return this.db.list(`/users/${key}/photoGallery`);
  }

  addToGallery(member, file) {
    let key = UniqueIdGenerator.generate();
    if (!member.photoGallery) {
      member.photoGallery = {};
    }
    member.photoGallery[key] = file.name;

    return firebase.storage().ref().child(`users/${member.$key}/gallery/${key}`)
                             .put(file)
                             .then( file => {
                                this.db.list('/users/').update(member.$key, member);
                              });
  }

  removeGalleryPhoto(member, fileKey) {
    firebase.storage().ref().child(`users/${member.$key}/gallery/${fileKey}`)
                            .delete();
    return this.db.list(`/users/${member.$key}/photoGallery`).remove(fileKey);
  }

  getRecentVendors(): FirebaseListObservable<any[]> {
    return this.db.list('/companies', {
      query: {
        orderByChild: 'companyType',
        equalTo: 'vendor',
        limitToLast: 6
      }
    });
  }

  getProviders(): FirebaseListObservable<any[]> {
    return this.db.list('/providers', {
      query: {
        orderByChild: 'startingTimestamp'
      }
    });
  }

  getProvider(key): FirebaseObjectObservable<any> {
    return this.db.object(`/providers/${key}`);
  }

  addProvider(provider, logoFile) {
    provider.creationTimestamp = firebase.database.ServerValue.TIMESTAMP;
    provider.creatorKey = this.adminUID;
    this.db.list('/providers').push(provider).then( item => {
      if (logoFile) {
        firebase.storage().ref().child(`providers/${item.key}/profileImage`)
                                .put(logoFile)
                                /* Trigger observable update after image is uploaded */
                                .then( () => {
                                  this.db.list('/providers').update(item.key, {});
                                });
      }
    });

  }

  updateProvider(key, value, logoFile) {
    if (logoFile) {
      return firebase.storage().ref().child(`providers/${key}/profileImage`)
                               .put(logoFile)
                               /* Trigger observable update after image is uploaded */
                               .then( () => {
                                 this.db.list('/providers').update(key, value);
                               });
    } else {
      return this.db.list('/providers').update(key, value);
    }
  }

  deleteProvider(key) {
    this.db.list('/providers').remove(key);

    firebase.storage().ref().child(`newsletters/${key}/profileImage`)
                            .delete();
  }

  getEvent(key): FirebaseObjectObservable<any> {
    return this.db.object(`/events/${key}`);
  }

  getEvents(): FirebaseListObservable<any[]> {
    var query = {
      orderByChild: 'startingTimestamp'
    };

    return this.db.list('/events', query);
  }

  addEvent(event, coverImg) {
    event.creationTimestamp = firebase.database.ServerValue.TIMESTAMP;
    event.creatorKey = this.adminUID;
    this.db.list('/events').push(event).then( item => {
      if (coverImg) {
        firebase.storage().ref().child(`events/${item.key}/coverImage`)
                                .put(coverImg);
      }
    });
  }

  updateEvent(key, value, coverImg) {
    this.db.list('/events').update(key, value);

    if (coverImg) {
      firebase.storage().ref().child(`events/${key}/coverImage`)
                              .put(coverImg);
    }
  }

  deleteEvent(key) {
    this.db.list('/events').remove(key);

    firebase.storage().ref().child(`events/${key}/coverImage`)
                            .delete();
  }

  getRecentEvents(): FirebaseListObservable<any[]> {
    var query = {
      orderByChild: 'startingTimestamp',
      limitToLast: 3
    };

    return this.db.list('/events', query);
  }

  getEventGallery(key) {
    return this.db.list(`/events/${key}/gallery`);
  }

  addToEventGallery(event, file) {
    let key = UniqueIdGenerator.generate();
    if (!event.gallery) {
      event.gallery = {};
    }
    event.gallery[key] = file.name;

    return firebase.storage().ref().child(`events/${event.$key}/gallery/${key}`)
                             .put(file)
                             .then( file => {
                                this.db.list('/events/').update(event.$key, event);
                              });
  }

  removeEventGalleryPhoto(event, fileKey) {
    firebase.storage().ref().child(`events/${event.$key}/gallery/${fileKey}`)
                            .delete();
    return this.db.list(`/events/${event.$key}/gallery`).remove(fileKey);
  }

  getNewsletter(key): FirebaseObjectObservable<any> {
    return this.db.object(`/newsletters/${key}`);
  }

  getNewsletters(): FirebaseListObservable<any[]> {
    return this.db.list('/newsletters', {
      query: {
        orderByChild: 'startingTimestamp'
      }
    });
  }

  addNewsletter(newsletter, file) {
    newsletter.creationDate = firebase.database.ServerValue.TIMESTAMP;
    newsletter.creatorKey = this.adminUID;
    this.db.list('/newsletters').push(newsletter).then( item => {
      if (file) {
        firebase.storage().ref().child(`newsletters/${item.key}/${newsletter.fileName}`)
                                .put(file);
      }
    });

  }

  updateNewsletter(key, value, file) {
    this.db.list('/newsletters').update(key, value);

    if (file) {
      firebase.storage().ref().child(`newsletters/${key}/${file.name}`)
                              .put(file);
    }
  }

  deleteNewsletter(key, fileName) {
    firebase.storage().ref().child(`newsletters/${key}/${fileName}`)
                            .delete();

    this.db.list('/newsletters').remove(key);
  }

  getResource(key): FirebaseObjectObservable<any> {
    return this.db.object(`/resources/${key}`);
  }

  getResources(): FirebaseListObservable<any[]> {
    return this.db.list('/resources', {
      query: {
        orderByChild: 'startingTimestamp'
      }
    });
  }

  addResource(resource, file) {
    resource.timestamp = firebase.database.ServerValue.TIMESTAMP;
    this.db.list('/resources').push(resource).then( item => {
      firebase.storage().ref().child(`resources/${item.key}/${resource.fileKey}`)
                              .put(file);
    });

  }

  updateResource(key, value, file) {
    this.db.list('/resources').update(key, value);

    // Upload file
    if (file) {
      firebase.storage().ref().child(`resources/${key}/${value.fileKey}`)
                              .put(file);
    }
  }

  deleteResource(key, fileKey) {
    // Remove file
    firebase.storage().ref().child(`resources/${key}/${fileKey}`)
                            .delete();

    this.db.list('/resources').remove(key);
  }


  getSurvey(key): FirebaseObjectObservable<any> {
    return this.db.object(`/surveys/${key}`);
  }

  getSurveys(): FirebaseListObservable<any[]> {
    return this.db.list('/surveys', {
      query: {
        orderByChild: 'timestamp'
      }
    });
  }

  addSurvey(survey) {
    survey.timestamp = firebase.database.ServerValue.TIMESTAMP;
    this.db.list('/surveys')
           .push(survey)
           .then( item => {
              let notificationKey = UniqueIdGenerator.generate();
              let notificationObj = {};
              notificationObj = {
                content: survey.name,
                contentDescription: "New Survey",
                contentKey: survey.surveyID,
                contentType: "survey",
                forumKey: null,
                seen: false,
                timestamp: firebase.database.ServerValue.TIMESTAMP
              }


              try {
                this.db.list('/users')
                      .subscribe(users => {
                          return users.map(user => {
                            return this.db.list(`/notifications/${user.$key}`).update(notificationKey, notificationObj);
                          });
                      });
              } catch (ex) {
                console.log("Exception: ", ex);
              }

              return this.backendService
                         .oneSignalNotification(survey.name, notificationKey)
                         .subscribe( data => {
                            console.log("DBS: ", data);
                         });
           });
  }

  updateSurvey(key, value) {
    this.db.list('/surveys').update(key, value);
  }

  deleteSurvey(key) {
    this.db.list('/surveys').remove(key);
  }


}



// WEBPACK FOOTER //
// ./src/app/db.service.ts